import script from "./NavbarNew.vue?vue&type=script&setup=true&lang=js"
export * from "./NavbarNew.vue?vue&type=script&setup=true&lang=js"

import "./NavbarNew.vue?vue&type=style&index=0&id=0e844a34&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e844a34"]])

export default __exports__